<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item ><div style="display: inline-block;" @click="gotopage('/Channel/index.html')">渠道管理</div></el-breadcrumb-item>
            <el-breadcrumb-item>额度明细</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" :model="item" class="search">
            <el-row>
                <el-form-item label="场景">
                    <el-select v-model="item.sence" clearable placeholder="场景" size="small">
                        <el-option label="所有" value="0"></el-option>
                        <el-option label="用户消费" value="20"></el-option>
                        <el-option label="管理员操作" value="30"></el-option>
                        <el-option label="订单退款" value="40"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="渠道来源">
                    <el-select v-model="item.channel_id" filterable clearable placeholder="渠道来源" size="small">
                        <el-option
                                v-for="item in options1"
                                :key="item.channel_id"
                                :label="item.name"
                                :value="item.channel_id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单号">
                    <el-input v-model="item.order_sn" clearable placeholder="请输入订单号" size="small"></el-input>
                </el-form-item>
                <el-form-item label="时间">
                    <el-date-picker size="small" style="margin-left: 10px" v-model="item.times" type="daterange"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit" size="medium">查询</el-button>
                    <el-button type="success" @click="excelOut" size="medium">导出</el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <el-table :data="list" border>
            <el-table-column prop="log_id" label="ID"></el-table-column>
            <el-table-column label="订单号" width="100">
                <template slot-scope="{row}">
                    {{row.order_sn}}
                </template>
            </el-table-column>
            <el-table-column prop="scene" label="场景">
                <template slot-scope="{row}">
                    <el-tag v-if="row.scene == 20">用户消费</el-tag>
                    <el-tag v-if="row.scene == 30">管理员操作</el-tag>
                    <el-tag v-if="row.scene == 40">订单退款</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="money" label="金额"></el-table-column>
            <el-table-column prop="log_desc" label="描述"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="create_time" label="时间"></el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                list: [],
                isLoad: false,
                limit: 20,
                page: 1,
                total: 0,
                item: {
                    sence: 0,
                    status: '1'
                },
                options1: []
            }
        },
        created() {
            this.loadList();
            this.getData()
        },
        methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
            getData() {
                this.axios.post('/admin/channel/list', {
                    pagesize: 0
                }).then(res => {
                    this.options1 = res.data.list;
                })
            },
            // 搜索查询
            submit() {
                this.page = 1
                this.loadList()
            },
            loadList() {
                this.isLoad = !this.isLoad
                this.axios.get('/admin/credit/list',{params:Object.assign({
                        page:this.page,
                        limit:this.limit
                    }, this.item)}).then(res => {
                    this.isLoad = !this.isLoad
                    this.list = res.data.list.data
                    this.total = res.data.list.total
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            sizeReload(val) {
                this.page = 1
                this.limit = val
                this.loadList()
            },
            pageReload(val) {
                this.page = val
                this.loadList()
            },
            // 导出
            excelOut() {
                if (this.isLoad) {
                    return false
                }

                this.isLoad = !this.isLoad
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.post('/admin/credit/listExport', this.item)
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '额度明细导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            formatJson (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
        }
    }
</script>
<style scoped>
</style>
